import { render } from "./termo.vue?vue&type=template&id=0d172521&scoped=true"
import script from "./termo.vue?vue&type=script&lang=js"
export * from "./termo.vue?vue&type=script&lang=js"

import "./termo.vue?vue&type=style&index=0&id=0d172521&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d172521"]])

export default __exports__